import { useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';

import { useMenuContext } from 'pages/ParentHelper/components/History/hooks';
import { useParentHelperContext } from 'pages/ParentHelper/providers/ParentHelperProvider/hooks';

import type { ChatId } from 'pages/ParentHelper/types';

export const useChatTopicStyles = (chatId: ChatId) => {
  const { chatId: selectedChatId } = useParentHelperContext();
  const { anchorEl } = useMenuContext();
  const { palette } = useTheme();

  const styles = [];
  const isChatSelected = selectedChatId === chatId;
  const isMenuSelected = anchorEl?.id === chatId;

  if (isChatSelected) {
    styles.push({ borderColor: 'primary.main', background: 'transparent' });
  }

  if (isChatSelected && isMenuSelected) {
    styles.push({
      borderColor: 'primary.main',
      backgroundColor: alpha(palette.primary.main, 0.04),
    });
  }

  if (!isChatSelected && isMenuSelected) {
    styles.push({
      background: palette.grey[300],
      borderColor: 'transparent',
    });
  }

  styles.push({
    '&:hover': { backgroundColor: alpha(palette.primary.main, 0.04) },
  });

  return styles;
};
